import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastContainerFn = /* @__PURE__ */ createRecipe('ToastContainer', {
  "placement": "top"
}, [])

const toastContainerVariantMap = {
  "placement": [
    "top-left",
    "top",
    "top-right",
    "bottom-left",
    "bottom",
    "bottom-right"
  ]
}

const toastContainerVariantKeys = Object.keys(toastContainerVariantMap)

export const toastContainer = /* @__PURE__ */ Object.assign(memo(toastContainerFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastContainer',
  __getCompoundVariantCss__: toastContainerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastContainerVariantKeys,
  variantMap: toastContainerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastContainerVariantKeys)
  },
  getVariantProps: toastContainerFn.getVariantProps,
})